import { Area, Point, TransformLine } from '../../type/common.interface';

// 获取线段在内容区域内存在的点集
export function getLinePointsInArea(
    line: TransformLine,
    area: Area,
): Point[] {
    if (typeof line === 'function') {
        const points: Point[] = [];

        for (let x = 0; x <= area.width; x ++) {
            const y = line(x);

            if (y === undefined) continue;

            if (y >= 0 && y <= area.height) {
                points.push({ x, y });
            }
        }

        return points;
    }

    const points: Point[] = [];

    line.forEach((opt) => {
        const operator = (x: number) => {
            const y = opt.line(x)[opt.lIndex]();
            if (y >= 0 && y <= area.height) {
                points.push({ x, y });
            }
        };

        if (opt.direction === 'increase') {
            for (let x = opt.startX; x <= opt.endX; x++) {
                operator(x);
            }
        }

        if (opt.direction === 'decrease') {
            for (let x = opt.startX; x >= opt.endX; x--) {
                operator(x);
            }
        }
    });


    return points;
}
